<template>
  <article
    class="accruals-config-card"
    data-testid="accruals-page__configuration-card"
    role="button"
    tabindex="0"
    @click="openConfiguration"
    @keydown.enter="openConfiguration"
    @keydown.space.prevent="openConfiguration"
  >
    <header class="accruals-config-card__header">
      <div class="accruals-config-card__title-group">
        <span class="accruals-config-card__icon-wrap">
          <img :src="assets.ICON_FILTER" alt="" class="accruals-config-card__icon" />
        </span>
        <h3 class="accruals-config-card__title">Configuration</h3>
      </div>
      <img
        :src="assets.ARROW_RIGHT"
        alt=""
        class="accruals-config-card__chevron"
        aria-hidden="true"
      />
    </header>

    <p class="accruals-config-card__description">
      Rules tell how to estimate each PO type. At least one rule is needed to run estimates.
    </p>

    <div class="accruals-config-card__options" @click.stop>
      <accruals-option-row
        v-for="option in options"
        :key="option.id"
        :id="option.id"
        :title="option.title"
        :subtitle="option.subtitle"
        :icon="option.icon"
        :badge="option.badge"
        :disabled="option.disabled"
        @click="openConfigurationOption(option.id)"
      />
    </div>
  </article>
</template>

<script>
import {
  ACCRUALS_ASSETS,
  ACCRUALS_CONFIGURATION_OPTIONS,
  ACCRUALS_ROUTES,
  formatRulesCountSubtitle,
} from '../accrualsPageConstants';
import { ACCRUALS_CONFIG_TABS } from '../accrualsConfigurationConstants';
import AccrualsOptionRow from './AccrualsOptionRow.vue';

export default {
  name: 'AccrualsConfigurationCard',
  components: { AccrualsOptionRow },
  props: {
    projectId: { type: String, required: true },
    estimationRulesCount: { type: Number, default: 0 },
    infoRequestRulesCount: { type: Number, default: 0 },
  },
  data() {
    return {
      assets: ACCRUALS_ASSETS,
    };
  },
  computed: {
    options() {
      return ACCRUALS_CONFIGURATION_OPTIONS.map((option) => {
        const isImportOption = option.id === 'import-previous-cycle';
        let subtitle = option.subtitle;
        let badge = option.badge || '';

        if (option.id === 'estimation-rules') {
          subtitle = formatRulesCountSubtitle(this.estimationRulesCount);
        } else if (option.id === 'info-request-rules') {
          subtitle = formatRulesCountSubtitle(this.infoRequestRulesCount);
        } else if (isImportOption) {
          subtitle = '';
          badge = '';
        }

        return {
          ...option,
          subtitle,
          badge,
          disabled: isImportOption,
        };
      });
    },
  },
  methods: {
    navigateToConfiguration(query = {}) {
      this.$nova.gotoLink({
        path: ACCRUALS_ROUTES.configuration(this.projectId),
        addquery: query,
      });
    },
    openConfiguration() {
      this.navigateToConfiguration();
    },
    openConfigurationOption(optionId) {
      if (optionId === 'import-previous-cycle') {
        this.$store.commit(
          'sbInfo',
          'Import from previous cycle is not wired yet — awaiting product flow.',
          { root: true },
        );
        return;
      }
      const tab = optionId === 'info-request-rules'
        ? ACCRUALS_CONFIG_TABS.INFO_REQUEST
        : ACCRUALS_CONFIG_TABS.ESTIMATION;
      this.navigateToConfiguration({ tab });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsConfigurationCard.scss';
</style>
